/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseSocial from 'scripts/social/base';

export default BaseSocial.extend({
    init: function () {
        this._super();
        this.apiUrl = this.appConfig.urls.api.facebook.apiUrl;
    },

    isApiAvailable: function () {
        return !!window.FB;
    },

    create: function (element) {
        this.initialize();
        this._parse(element);
    },

    onApiLoaded: function () {
        if (window.FB && window.FB.init) {
            window.FB.init({
                version: 'v3.0',
                appId: '',
                xfbml: true
            });
        }
        this._super();
    },

    _parse: function (element) {
        this.socialAwaiting.then(function () {
            if (window.FB && window.FB.XFBML && window.FB.XFBML.parse) {
                window.FB.XFBML.parse(this.$(element)[0]);
            }
        }.bind(this));
    }

}, {});
